/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type OverrideOutScope = typeof OverrideOutScope[keyof typeof OverrideOutScope];


export const OverrideOutScope = {
  occurrence: 'occurrence',
  series: 'series',
} as const;
